export default __webpack_public_path__ + "static/media/understanding_the_indicators_3.dffb40fa.png";